import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { isNull } from 'lodash'
import { Link } from 'react-router-dom'
import { Card } from 'material-ui/Card'
import WayPoint from 'react-waypoint'

import { loadSwaps, loadMoreSwaps, unloadSwaps } from '../actions'
import {
  getSwaps,
  canLoadMoreSwaps,
  getTotalSwaps,
  getSwapsLoading,
} from '../selectors'
import Spinner from '../common/Spinner'
import NoResults from '../common/NoResults'
import NotificationsListItem from '../common/NotificationsListItem'

const styles = {
  containerStyle: {
    margin: 10,
  },
}

class Notifications extends PureComponent {
  componentDidMount() {
    this.props.loadSwaps({
      type: 'proposte_a_me',
      status: 'proposta',
    })
  }

  componentWillUnmount() {
    this.props.unloadSwaps()
  }

  loadMore = () => {
    this.props.loadMoreSwaps({
      type: 'proposte_a_me',
      status: 'proposta',
    })
  }

  render() {
    const { user, swaps, loading, canLoadMoreSwaps } = this.props

    return (
      <div>
        {/* Loading swaps spinner */}
        {loading && isNull(swaps) && <Spinner centered />}

        {!isNull(swaps) &&
          swaps.length > 0 &&
          <div>
            {swaps.map(swap => (
              <Card style={styles.containerStyle} key={swap.id}>
                <Link to={`/swap/${swap.id}`}>
                  <NotificationsListItem user={user} swap={swap} />
                </Link>
              </Card>
            ))}
          </div>}

        {!loading &&
          !isNull(swaps) &&
          swaps.length === 0 &&
          <NoResults>
            Nessuna notifica
          </NoResults>}

        {/*  Loading more swaps spinner */}
        {loading && !isNull(swaps) && swaps.length > 0 && <Spinner centered />}

        {/* Trigger load more */}
        {!loading &&
          !isNull(swaps) &&
          swaps.length > 0 &&
          canLoadMoreSwaps &&
          <WayPoint onEnter={this.loadMore} />}
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  user: state.auth.user,
  swaps: getSwaps(state),
  totalSwaps: getTotalSwaps(state),
  canLoadMoreSwaps: canLoadMoreSwaps(state),
  loading: getSwapsLoading(state),
})

export default connect(mapStateToProps, {
  loadSwaps,
  loadMoreSwaps,
  unloadSwaps,
})(Notifications)



// WEBPACK FOOTER //
// ./src/pages/Notifications.js